import { useEffect, useState } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useLenis } from "@/hooks/useLenis";
import { useReducedMotion } from "@/hooks/useReducedMotion";
import Loader from "@/pages/home/components/Loader";
import Nav from "@/pages/home/components/Nav";
import SceneHero from "@/pages/home/components/SceneHero";
import SceneInsideR from "@/pages/home/components/SceneInsideR";
import SceneShips from "@/pages/home/components/SceneShips";
import SceneCapabilities from "@/pages/home/components/SceneCapabilities";
import SceneWork from "@/pages/home/components/SceneWork";
import SceneIndex from "@/pages/home/components/SceneIndex";
import SceneClimax from "@/pages/home/components/SceneClimax";
import SceneCTA from "@/pages/home/components/SceneCTA";

gsap.registerPlugin(ScrollTrigger);

export default function Home() {
  const [ready, setReady] = useState(false);
  const reduced = useReducedMotion();
  useLenis(reduced);

  useEffect(() => {
    if (!ready) return;
    // wait for fonts before ScrollTrigger recalcs
    const run = () => {
      ScrollTrigger.refresh();
    };
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(run);
    } else {
      run();
    }

    const onResize = () => ScrollTrigger.refresh();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [ready]);

  return (
    <>
      <a href="#scene-hero" className="skip-link">Skip to content</a>

      {!ready && <Loader onDone={() => setReady(true)} />}

      {ready && (
        <>
          <Nav />
          <main>
            <SceneHero />
            <SceneInsideR />
            <SceneShips />
            <SceneCapabilities />
            <SceneWork />
            <SceneIndex />
            <SceneClimax />
            <SceneCTA />
          </main>
        </>
      )}
    </>
  );
}